// export const baseURL = '/api';
// export const baseURL = 'https://test.sanctuarytech.co';//测试
export const baseURL = 'https://cs.vip.jjlin.tech';
export const uploadURL = baseURL + '/api-cms/image';